export { default } from "./RedeemSwipeNew";